// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shrink-vertical"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.5 18.5L12 15L8.5 18.5M20 12H4M15.5 5.5L12 9L8.5 5.5M12 2.5V7.75M12 21.5V16.25","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ShrinkVerticalIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shrink-vertical',
    ref,
    icon: element,
  },
));

ShrinkVerticalIcon.displayName = 'ShrinkVerticalIcon';

export default ShrinkVerticalIcon;
